// Some privacy-hardened browsers report this placeholder instead of a zone.
const UNKNOWN_TIMEZONE = 'Etc/Unknown';

/** The browser's IANA timezone (e.g. "America/New_York"), or undefined when it can't tell. */
export const getBrowserTimezone = (): string | undefined => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timezone && timezone !== UNKNOWN_TIMEZONE ? timezone : undefined;
};

/**
 * Every IANA timezone the browser knows, plus `current` when it's missing from
 * that list: browsers list canonical names only, but may report (and so have
 * stored) an alias such as "Asia/Calcutta".
 */
export const getTimezoneOptions = (current?: string | null): string[] => {
  const timezones = Intl.supportedValuesOf('timeZone');

  return current && !timezones.includes(current)
    ? [current, ...timezones]
    : timezones;
};

/** A readable timezone label with its current UTC offset, e.g. "America/New York (GMT-4)". */
export const formatTimezoneLabel = (timezone: string): string => {
  const offset = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    timeZoneName: 'shortOffset'
  })
    .formatToParts(new Date())
    .find((part) => part.type === 'timeZoneName')?.value;
  const name = timezone.replace(/_/g, ' ');

  return offset ? `${name} (${offset})` : name;
};
